import {Injectable} from '@angular/core';

import {HttpClient} from '@angular/common/http';
import {map} from 'rxjs/operators';

@Injectable({providedIn: 'root'})
export class Warp10Connector {
  warp10URL = 'https://truesea.senx.io/api/v0/exec';

  constructor(private http: HttpClient) {
  }

  getShips(location: string, startDate: number, duration: number): Promise<any> {
    return this.http.post(this.warp10URL,
      `'_BhlkLTrzrOsDQm41Cn3L1uatm8Xw.tBYcOjdcRGAjuX3YLxejRuNAT.cCqBaC9t4t9wPmOFzqS8QUKirs_IGaN7lSRESyBIkPuM1Z1GndRGZPUb3YTDCcQCe3qtDs1HMZvP48gp1ThH4hrW9wJGLGT_zroOVK_5WvwR0VRDIlSICqjzWq.GYTwaQj97Izk94xH5RilVoryM8Xmoj64Yuw_9xBaqhNCjGvRu9bAt.2x_QHGnPHXJPdOg96lYA3GS' CAPADD
      '${location}' ${startDate} ${duration} d 1000 / @senx/truesea/demo`)
      .pipe(
        map(r => {
          return {
            headers: {},
            body: r
          };
        })
      ).toPromise();
  }
}
